var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{ref:"wrapper",staticClass:"z-10 flex items-center",class:{'absolute left-0 right-0': _vm.absolute, 'flex-wrap': _vm.wrap},style:({flexDirection: _vm.direction, gap: _vm.gap, justifyContent: _vm.justifyContent, padding: _vm.padding, width: _vm.w === '100%' ? _vm.w : 'unset'})},_vm._l((_vm.skeletons),function(skeleton){return _c('div',{key:skeleton,staticClass:"max-w-desktop bg-[length:400%_400%] animate-pulse duration-200",style:({
      width: _vm.w,
      height: _vm.h,
      borderRadius: _vm.br,
      background:
        _vm.theme === 'light'
          ? 'linear-gradient(90deg, #afafaf 0%, #e6e6e6 100%)'
          : 'linear-gradient(90deg, rgb(80, 80, 80) 0%, rgb(110, 110, 110) 100%)'
    })})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }